import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  title: {
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: "18px",
    lineHeight: "24px",
    color: "#465869",
    height: "auto !important",
  },
}));

export default styles;
